var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("span", [
    _c("input", {
      directives: [
        {
          name: "model",
          rawName: "v-model",
          value: _vm.sort_output.sort_order,
          expression: "sort_output.sort_order",
        },
      ],
      staticStyle: {
        display: "inline-block",
        "max-width": "50px",
        padding: "5px",
      },
      attrs: { type: "number", min: "0", name: "sort_order" },
      domProps: { value: _vm.sort_output.sort_order },
      on: {
        input: [
          function ($event) {
            if ($event.target.composing) return
            _vm.$set(_vm.sort_output, "sort_order", $event.target.value)
          },
          function ($event) {
            return _vm.updateInput($event)
          },
        ],
      },
    }),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }